"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterOperationEnum = exports.BooleanFilterOperation = exports.MultiselectFilterOperation = exports.NumberFilterOperation = exports.StringFilterOperation = exports.DateFilterOperation = exports.FilterType = void 0;
var FilterType;
(function (FilterType) {
    FilterType["Date"] = "Date";
    FilterType["String"] = "String";
    FilterType["Number"] = "Number";
    FilterType["Multiselect"] = "Multiselect";
    FilterType["Boolean"] = "Boolean";
})(FilterType || (exports.FilterType = FilterType = {}));
var DateFilterOperation;
(function (DateFilterOperation) {
    DateFilterOperation["Before"] = "Before";
    DateFilterOperation["After"] = "After";
    DateFilterOperation["DateRange"] = "DateRange";
    DateFilterOperation["Is"] = "Is";
})(DateFilterOperation || (exports.DateFilterOperation = DateFilterOperation = {}));
var StringFilterOperation;
(function (StringFilterOperation) {
    StringFilterOperation["Contains"] = "Contains";
    StringFilterOperation["EqualAt"] = "EqualAt";
    StringFilterOperation["ContainsWithFuzzy"] = "ContainsWithFuzzy";
})(StringFilterOperation || (exports.StringFilterOperation = StringFilterOperation = {}));
var NumberFilterOperation;
(function (NumberFilterOperation) {
    NumberFilterOperation["GreaterThan"] = "GreaterThan";
    NumberFilterOperation["LessThan"] = "LessThan";
    NumberFilterOperation["NumberRange"] = "NumberRange";
})(NumberFilterOperation || (exports.NumberFilterOperation = NumberFilterOperation = {}));
var MultiselectFilterOperation;
(function (MultiselectFilterOperation) {
    MultiselectFilterOperation["In"] = "In";
    MultiselectFilterOperation["NotIn"] = "NotIn";
})(MultiselectFilterOperation || (exports.MultiselectFilterOperation = MultiselectFilterOperation = {}));
var BooleanFilterOperation;
(function (BooleanFilterOperation) {
    BooleanFilterOperation["EqualAt"] = "EqualAt";
})(BooleanFilterOperation || (exports.BooleanFilterOperation = BooleanFilterOperation = {}));
exports.FilterOperationEnum = {
    ...DateFilterOperation,
    ...StringFilterOperation,
    ...MultiselectFilterOperation,
    ...NumberFilterOperation,
    ...BooleanFilterOperation,
};
